import axios from 'axios';
import { SetPinRequest } from '../../types/PinStatus';

class PinStatusService {
  async getAll(): Promise<any[]> {
    const result = await axios.get('/pin-status');
    return result.data;
  }

  async setPin(request: SetPinRequest): Promise<void> {
    await axios.put('/pin-status', request);
  }
}

const pinStatusService = new PinStatusService();
export default pinStatusService;
